import React, { useState } from 'react';
import { CARD_DIRECTIVE_TYPES, ICONS } from '../../constants/enums';
import { generateUniqueInteger } from '../../services/formatter';
import { CardDirectiveType } from '../../types/api/card';
import { FEATURE_FLAGS } from '../../constants/featureFlags';

import Alert from '../Common/Alerts/Alert';
import DirectiveText from '../Common/DirectiveText';
import Modal from '../Common/Modal';
import DyanmicalModal from '../Common/DynamicModal';
import { GAEventType } from '../../types/general';

const Alerts = ({ directives, featureFlags, className }: { directives: CardDirectiveType[], featureFlags?: string[], className?: string }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState<{
    title: string;
    content: React.ReactNode;
    actions: any[];
  }>({
    title: "",
    content: "",
    actions: []
  });
  const [dynamicModalOpen, setDynamicModalOpen] = useState(false);
  const [dynamicModalConfig, setDynamicModalConfig] = useState<{
    header: string | React.ReactNode;
    content: string | React.ReactNode;
    actions: any[];
    onCloseEvent?: GAEventType;
  }>({
    header: "",
    content: "",
    actions: [],
    onCloseEvent: undefined
  });

  return (
    <>
      {directives?.map((notification: CardDirectiveType) => {
        const isMobileWallet = notification.directives?.some(d => d.directiveType === CARD_DIRECTIVE_TYPES.SEND_MONEY);
        const isMCToAccount = notification.directives?.some(d => d.directiveType === CARD_DIRECTIVE_TYPES.NEW_TOACCOUNT_OPTIONS_TRY_NOW);

        if (featureFlags?.includes(FEATURE_FLAGS.RR_WEB_SDK_KILLSWITCH) && (isMobileWallet || isMCToAccount)) {
          return null; // Skip rendering MC To Acount or Mobile Wallet alert if killswitch is enabled
        }

        return (
          <Alert
            key={generateUniqueInteger()}
            alertClasses={`alert-info flex-row align-items-start w-full ${className}`}
            isHTML={true}
            icon={ICONS.INFO}
            iconClasses={"spacing-right-tiny"}
          >
            <DirectiveText
              text={notification.message}
              directives={notification.directives}
              setModalConfig={setModalConfig}
              setModalOpen={setModalOpen}
              setDynamicModalConfig={setDynamicModalConfig}
              setDynamicModalOpen={setDynamicModalOpen}
            />
          </Alert>
        )
      })}

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        title={modalConfig.title}
        content={modalConfig.content}
        actions={modalConfig.actions}
      />

      <DyanmicalModal
        open={dynamicModalOpen}
        setClose={setDynamicModalOpen}
        showCloseIcon={true}
        className="max-w-450"
        header={dynamicModalConfig.header}
        body={dynamicModalConfig.content}
        onCloseEvent={dynamicModalConfig?.onCloseEvent}
      />
    </>
  );
}

export default Alerts;